(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.searchBar
   */
  angular
    .module("akitabox.mobile.directives.searchBar", ["akitabox.core"])
    .directive("abmSearchBar", AbmSearchBarDirective);

  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.searchBar
   * @name AbmSearchBarDirective
   *
   * @restrict E
   *
   * @description
   * `<abm-search-bar>` allows a toolbar button to toggle a dropdown search bar
   */

  /* @ngInject */
  function AbmSearchBarDirective(
    $compile,
    $http,
    $log,
    $timeout,
    $templateCache
  ) {
    return {
      restrict: "A",
      link: postLink,
      scope: {
        searchText: "=abmSearchText",
        shown: "=?abmSearchOpen",
      },
    };

    function postLink($scope, $element) {
      var templateUrl = "app/mobile/directives/search-bar/search-bar.html";

      if (!angular.isDefined($scope.shown)) {
        $scope.shown = false;
      }

      // Constants
      var SPEED = 0.2; // seconds
      var TOGGLE_DEBOUNCE = 180; // milliseconds
      var TAG_BODY = "BODY";
      var TAG_BUTTON = "BUTTON";
      var TAG_MD_ICON = "MD-ICON";
      var TAG_TOOLBAR = "MD-TOOLBAR";
      var SEARCH_ICON = "search";
      var CLOSE_ICON = "close";
      var ELEVATION_FRAME_CLASS = "elevation-frame-1dp";
      var TRANSITION = "all " + SPEED + "s ease";

      // UI elements
      var $parent = $element;
      var $searchBar;
      var $icon;

      var isButton = $element[0].tagName === TAG_BUTTON;
      var isMdIconBtn = false;
      var hasElevationFrame = false;

      var debouncedToggle = angular.debounce(toggle, TOGGLE_DEBOUNCE, false);

      // Find button material icon
      if (isButton) {
        $icon = angular.element($element.children()[0]);
        isMdIconBtn =
          $icon[0].tagName === TAG_MD_ICON && $icon.hasClass("material-icons");
      }

      // Traverse up the DOM tree until we hit md-toolbar or body elements
      // If we hit the body element, we've gone too far
      while ($parent[0].tagName !== TAG_BODY) {
        if ($parent[0].tagName === TAG_TOOLBAR) {
          hasElevationFrame = $parent.hasClass(ELEVATION_FRAME_CLASS);
          return attachSearchBar($parent);
        }
        $parent = angular.element($parent.parent());
      }

      return $log.error(
        "<abm-search-field> can only exist inside of an <md-toolbar>"
      );

      /**
       * Attach the (hidden) search bar element to the DOM
       */
      function attachSearchBar() {
        $http
          .get(templateUrl, { cache: $templateCache })
          .then(function (res) {
            if (res.status === 200) {
              $searchBar = angular.element($compile(res.data)($scope));
              $searchBar.css({
                "transform-origin": "top",
                transition: TRANSITION,
                "z-index": "0",
              });
              $parent.after($searchBar);
              $element.on("click", debouncedToggle);

              // Show the search bar if this directive was initialized
              if ($scope.shown) {
                showSearchBar();
              }
            } else {
              $log.error("Unable to retrieve <abm-search-bar> template");
            }
          })
          .catch(function (err) {
            $log.error(err);
          });
      }

      /**
       * Toggle the search bar
       */
      function toggle() {
        if ($scope.shown) {
          $scope.searchText = null;
          hideSearchBar();
        } else {
          showSearchBar();
        }
        $scope.shown = !$scope.shown;
      }

      /**
       * Hide the search bar
       */
      function hideSearchBar() {
        $searchBar.css({
          transform: "translateY(0px)",
          "z-index": "0",
        });
        // Change icon to close 'x'
        if (isMdIconBtn) $icon.html(SEARCH_ICON);
        $timeout(function () {
          $searchBar.css(
            "transform",
            "translateY(-" + $parent[0].offsetHeight + "px)"
          );
          // If element had a elevation-frame, re-add it
          if (hasElevationFrame) $parent.addClass(ELEVATION_FRAME_CLASS);
        }, SPEED * 100);
      }

      /**
       * Show the search bar
       * @return {[type]} [description]
       */
      function showSearchBar() {
        $searchBar.css(
          "transform",
          "translateY(-" + $parent[0].offsetHeight + "px)"
        );
        // Change icon to manifier
        if (isMdIconBtn) $icon.html(CLOSE_ICON);
        $timeout(function () {
          $searchBar.css({
            transform: "translateY(0px)",
            "z-index": "1",
          });
          // If element has elevation-frame, remove it
          if (hasElevationFrame) $parent.removeClass(ELEVATION_FRAME_CLASS);
        }, SPEED * 100);
      }
    }
  }
})();
